// import FlightModalContent from './components/FlightModalContent/FlightModalContent';
import Location from './components/Location/Location';
import FlightInfoSegment from './components/FlightInfoSegment/FlightInfoSegment';
import FareGroup from './components/FareGroup/FareGroup';
import Cell from './components/CompareFares/Cell';
import StepbarWithShoppingCart from './components/ShoppingCart/ShoppingCart';
import SearchFormAdaptiveButtons from './theme/components/SearchFormDatepickerRenderers/SearchFormDatepickerMobileButtons';
import SegmentPlaneInfo from './components/SegmentPlaneInfo/SegmentPlaneInfo';
// import Contacts from '@websky/core/src/Contacts';
import CompareFaresSlider from './components/CompareFaresSlider/CompareFaresSlider';
import PassengersCloseBtn from './components/SearchForm/Passengers/CloseBtn/CloseBtn';
import DatepickerValue from './components/DatepickerValue/DatepickerValue';
import SelectedFlight from './components/Checkout/SelectedFlight/SelectedFlight';
import CurrencyWarning from './components/Checkout/CurrencyWarning/CurrencyWarning';
import PromoCodeForm from './components/PromoCodeForm/PromoCodeForm';
import PassengerToolbarAdditional from './components/Checkout/PassengerToolbar/PassengerToolbarAdditional';
import SpecialEqupmentBaggageCard from './components/Baggage/SpecialEqupment/BaggageCard';
import CheckinNotification from './theme/components/Notification/CheckinNotification';
import DescriptionRender from './theme/components/FareConditions/DescriptionRender';
import { redwingsEquipmentIcons, specialEquipmentItemsSort } from './components/HeaderEquipmentIcon/icons';
import CheckoutFormPassenger from './components/CheckoutFormPassenger/CheckoutFormPassenger';
import CheckoutForm from './components/CheckoutForm/CheckoutForm';
import BaggageBody from './components/Baggage/UpgradeBaggageDialog/BaggageBody/BaggageBody';
import PassengerFormField from './components/CheckoutFormPassenger/PassengerFormField';
import CheckoutContacts from './components/CheckoutFormPassenger/CheckoutContacts';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService';
import SearchFormBeforeAdornment from './components/SearchForm/BeforeAdornment/BeforeAdornment';
import PassengersNotifications from './components/Checkout/PassengersNotifications/PassengersNotifications';
import CheckoutConfirmedOrderAdditionalBanner from './components/Checkout/ConfirmedOrderAdditionalBanner/ConfirmedOrderAdditionalBanner';
import CompletedCheckinAdditionalBanner from './components/Checkin/CompletedCheckinAdditionalBanner/CompletedCheckinAdditionalBanner';
import { redwingsPaymentIcons } from './components/icons';
import PriceParts from './components/PaymentForm/PriceParts/PriceParts';
import SeatMapServiceContent from './components/SeatMapServiceContent/SeatMapServiceContent';
import Business from './components/CheckoutAdditionalService/Business/Business';
import WarningDescription from './components/FareLock/WarningDescription';
import InsuranceCardOptions from './components/InsurancePopup/InsuranceCard/InsuranceCardOptions';
import OrderInsuranceBlockSlotUpsale from '../../core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import { FareFeaturePaymentType } from '@websky/graphql';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export default {
    // FlightDesktopFlightModalContent: FlightModalContent,
    CheckinNotification: CheckinNotification,
    DescriptionRenderers: DescriptionRender,
    FareGroupGrid: FareGroup,
    FlightInfoLocation: Location,
    renderFlightInfoSegment: FlightInfoSegment,
    RenderWarningDescription: WarningDescription,
    CheckoutDesktopStepbar: StepbarWithShoppingCart,
    CheckoutSelectedFlight: SelectedFlight,
    CheckoutCurrencyWarning: CurrencyWarning,
    renderAdaptiveSearchFormDatepickerControls: SearchFormAdaptiveButtons,
    renderSegmentPlaneInfo: SegmentPlaneInfo,
    Cell,
    renderCompareFaresSlider: CompareFaresSlider,
    SearchFormPassengersCloseBtn: PassengersCloseBtn,
    renderDatepickerValue: DatepickerValue,
    renderPromoCodeForm: PromoCodeForm,
    Baggage: {
        SpecialEqupment: {
            BaggageCard: SpecialEqupmentBaggageCard
        }
    },
    renderBaggageBody: BaggageBody,
    renderHeaderEquipmentIcon: rfics => redwingsEquipmentIcons === null || redwingsEquipmentIcons === void 0 ? void 0 : redwingsEquipmentIcons[rfics],
    CheckoutFormPassenger,
    CheckoutForm,
    specialEquipmentItemsSort: specialEquipmentItemsSort,
    PassengerFormField,
    CheckoutContacts,
    CheckoutAdditionalService: {
        CheckoutAdditionalService
    },
    SearchFormRenderers: {
        BeforeAdornment: SearchFormBeforeAdornment
    },
    CheckoutPassengersNotifications: PassengersNotifications,
    Paid: () => redwingsPaymentIcons === null || redwingsPaymentIcons === void 0 ? void 0 : redwingsPaymentIcons[FareFeaturePaymentType.Pay],
    NotIncluded: () => redwingsPaymentIcons === null || redwingsPaymentIcons === void 0 ? void 0 : redwingsPaymentIcons[FareFeaturePaymentType.NotAvailable],
    Included: () => redwingsPaymentIcons === null || redwingsPaymentIcons === void 0 ? void 0 : redwingsPaymentIcons[FareFeaturePaymentType.Free],
    renderPassengersToolbarAdditional: PassengerToolbarAdditional,
    CheckoutOrderAdditionalBanner: CheckoutConfirmedOrderAdditionalBanner,
    CheckinOrderAdditionalBanner: CompletedCheckinAdditionalBanner,
    PriceParts,
    SeatMapServiceContent,
    CheckoutBusiness: Business,
    renderInsuranceCardOptions: InsuranceCardOptions,
    CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
    CheckinServices: CheckinServicesV2
};
